import { useCallback, useMemo, useRef } from 'react';
import { useVariable } from './useVariable';
export const useNodeRef = (initialRef, onInit) => {
  const nodeRef = useRef(null);
  const handleInit = useVariable(onInit);
  const setRef = useCallback(ref => {
    if (ref && ref !== nodeRef.current) {
      if (initialRef) {
        initialRef.current = ref;
      }
      nodeRef.current = ref;
      handleInit.current?.(ref);
    }
  }, []);
  return useMemo(() => [setRef, nodeRef], []);
};